import { createRoot } from 'react-dom/client';
import { loadGoogleMapsScript } from '@/utils/loadGoogleMapsScript';
import App from '@app/App';
import { store, persistor } from '@app/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import { theme } from './Theme';
import GlobalStyles from './GlobalStyles';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';

loadGoogleMapsScript();

const root = createRoot(document.getElementById('root')!);

root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <GlobalStyles />
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
);

serviceWorker.unregister();
